import type { FirebaseApp } from "firebase/app";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

import { getFirebaseAppCheckSiteKey } from "@/lib/firebase/config";

let initialized = false;

/** Initializes App Check once on the client. No-op without a site key or on the server. */
export function initFirebaseAppCheck(app: FirebaseApp): void {
  if (initialized || typeof window === "undefined") {
    return;
  }

  const siteKey = getFirebaseAppCheckSiteKey();
  if (!siteKey) {
    if (process.env.NODE_ENV === "development") {
      console.warn(
        "[App Check] NEXT_PUBLIC_FIREBASE_APP_CHECK_SITE_KEY is missing; App Check disabled.",
      );
    }
    return;
  }

  initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider(siteKey),
    isTokenAutoRefreshEnabled: true,
  });
  initialized = true;
}
